export default __webpack_public_path__ + "static/media/bubblesLogo1.8a2d1614.png";